import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Trường Đại học Giao thông vận tải",
    src: _imports_0,
    class: "max-w-full"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-600 mt-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("b", { class: "underline" }, "Lưu ý:"),
    /*#__PURE__*/_createTextVNode(" Trang đăng ký xét tuyển này chỉ dành cho 2 đối tượng thí sinh. ")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "mt-0" }, [
    /*#__PURE__*/_createElementVNode("li", null, " Thí sinh tốt nghiệp từ 2025 về trước có nguyện vọng xét tuyển học bạ vào trường ĐH GTVT. "),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Thí sinh tốt nghiệp THPT sử dụng chứng chỉ IELTS, giấy chứng nhận đạt giải Nhất/Nhì/Ba học sinh giỏi cấp Tỉnh/TP để cộng điểm thưởng; điểm môn vẽ Mỹ thuật để xét tuyển ngành Kiến trúc. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Thí sinh tốt nghiệp năm 2026 có nguyện vọng xét tuyển học bạ sẽ đăng ký trên hệ thống của Bộ từ 02/07-14/07/2026 theo lịch chung cùng các phương thức xét tuyển khác. ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "col-12 flex flex-column gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = { class: "text-3xl" }
const _hoisted_8 = { class: "p-error flex flex-column gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "underline" }, "Lưu ý:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "Yêu cầu thí sinh lưu lại mã hồ sơ và mật khẩu để phục vụ tra cứu hồ sơ.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, "Mỗi Căn cước công dân chỉ được lưu 1 lần.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, " Thí sinh vui lòng nộp lệ phí xét tuyển trong vòng 24 giờ kể từ lúc này để hoàn tất thủ tục đăng ký xét tuyển. Để nộp lệ phí xét tuyển, thí sinh quét mã thanh toán lệ phí xét tuyển hiển thị dưới đây. ", -1)
const _hoisted_13 = {
  key: 0,
  class: "flex flex-column flex-wrap text-indigo-500"
}
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row gap-2 text-sm h-2rem"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Mã hồ sơ", -1)
const _hoisted_16 = { class: "col-12 sm:col-8" }
const _hoisted_17 = {
  key: 1,
  class: "flex flex-row gap-2 text-sm h-2rem"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Email", -1)
const _hoisted_19 = { class: "col-12 sm:col-8" }
const _hoisted_20 = {
  key: 2,
  class: "flex flex-row gap-2 text-sm h-2rem"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium pt-2" }, "Mật khẩu tra cứu thông tin hồ sơ", -1)
const _hoisted_22 = { class: "col-12 sm:col-8" }
const _hoisted_23 = { class: "flex flex-row gap-1" }
const _hoisted_24 = { class: "flex flex-row gap-2 text-sm h-2rem" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Tra cứu hồ sơ", -1)
const _hoisted_26 = { class: "col-12 sm:col-8" }
const _hoisted_27 = { class: "flex flex-row gap-3" }
const _hoisted_28 = {
  key: 3,
  class: "flex flex-row gap-2 text-sm h-2rem"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Sửa thông tin đăng ký xét tuyển", -1)
const _hoisted_30 = { class: "col-12 sm:col-8" }
const _hoisted_31 = { class: "flex flex-row gap-3" }
const _hoisted_32 = {
  key: 4,
  class: "flex flex-row gap-2 text-sm h-2rem"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Thời hạn sửa thông tin đăng ký xét tuyển ", -1)
const _hoisted_34 = { class: "col-12 sm:col-8 pt-2" }
const _hoisted_35 = {
  key: 5,
  class: "flex flex-row gap-2 text-sm"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 sm:col-4 font-medium" }, "Mã thanh toán lệ phí xét tuyển", -1)
const _hoisted_37 = { class: "col-12 sm:col-8 pt-2" }
const _hoisted_38 = { class: "flex flex-row flex-wrap gap-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ol", { class: "p-error" }, [
    /*#__PURE__*/_createElementVNode("li", null, " Mỗi Căn cước công dân chỉ được lưu 1 lần, vui lòng kiểm tra kỹ các thông tin trước khi đăng ký. "),
    /*#__PURE__*/_createElementVNode("li", null, " Thí sinh kiểm tra thật kỹ địa chỉ email đã đăng ký vì email này sẽ hỗ trợ thí sinh các bước tiếp theo. "),
    /*#__PURE__*/_createElementVNode("li", null, " Tôi xin cam đoan các thông tin và minh chứng khai trên là hoàn toàn chính xác và xin chịu trách nhiệm trước pháp luật về những thông tin khai trên. ")
  ])
], -1)
const _hoisted_40 = {
  key: 0,
  class: "flex flex-column gap-2"
}
const _hoisted_41 = { class: "p-error" }

import { onMounted, ref, watch, watchEffect } from "vue";
import Button from "primevue/button";
import Card from "primevue/card";
import Dialog from "primevue/dialog";
import ThongTinChung from "@/components/ThongTinChung.vue";
import DanhSachNguyenVong from "@/components/DanhSachNguyenVong.vue";
import KetQuaHocTap from "@/components/KetQuaHocTap.vue";
import MinhChung from "@/components/MinhChung.vue";
import NoiHoc from "@/components/NoiHoc.vue";
import ProgressSpinner from 'primevue/progressspinner';
import PageLoading from '@/components/PageLoading.vue';
import { Form, InvalidSubmissionContext, useFormValues } from 'vee-validate';
import { schema } from '@/validations/app.model'
import axios, { AxiosError } from "axios";
import { MethodResult } from "@/models/MethodResult.model";
import { Options } from "@/models/Options.model";
import { computed } from "@vue/reactivity";
import { useRoute } from "vue-router";
import moment from 'moment';
import { getCacheWithExpiry, setCacheWithExpiry } from '@/utilities/cacheWithExpiry'
import { isArray } from "@vue/shared";
import Image from 'primevue/image';

const __default__ = {
    name: "App",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const format = require('accounting-js');
const isViewMode = ref(false);
const router = useRoute();
const loading = ref(true);
const submitting = ref(false);
const token = ref<string | null>(null);
const visibleDialog = ref(false);
const visibleNotice = ref(false);
const registration = ref();
const validateMessages = ref<(string | undefined)[]>([]);
const item = ref<any>({});
const breakpoints = { '960px': '75vw', '641px': '100vw' }
const onRegister = (values: any, actions: any) => {
    console.log(registration.value, values);
    visibleDialog.value = true;

}
const inputType = ref<string>('password');
const notices = ref<any>(null);
const options = ref<Options>({
    academicRanks: [],
    conductRanks: [],
    districts: [],
    methods: [],
    priorityAreas: [],
    priorityObjects: [],
    provinces: [],
    fields: [],
    foreignSubjects: [],
    ieltsDateAfter: null,
    registrationFee: 0,
});
// watch(
//     () => registration.value,
//     () => {
//         localStorage.setItem("registration", JSON.stringify(registration.value));
//     },
//     {
//         deep: true,
//     }
// );

const initializeAsync = async () => {
    const responseOptions = await axios.get<MethodResult<Options>>('/helper/options');
    const responseOptionsData = responseOptions.data;
    if (responseOptionsData.data) {
        options.value = responseOptionsData.data;
        if (responseOptionsData.data.priorityAreas.length) {
            localStorage.setItem("options", JSON.stringify(responseOptionsData.data));
        }
    }
    token.value = router.params && router.params.token ? router.params.token as string : null;
    var url = token.value ? `/registration/thay-doi-thong-tin/${token.value}` : '/registration';
    const response = await axios.get(url);
    registration.value = response.data.data;
    if (registration.value.gender == -1) {
        registration.value.gender = null
    }
    if (!registration.value.graduationYear && !token.value) {
        registration.value.graduationYear = new Date().getFullYear();
    }

}
watch(() => registration.value?.fullName, (name: string) => {
    if (name) {
        registration.value.fullName = name.toUpperCase();
    }
})
watch(() => registration.value?.ieltsMark, (mark: any) => {
    if (!mark) {
        registration.value.ieltsDate = null;
    }
})
onMounted(() => {
    initializeAsync().then(() => {
        console.log('0k');
    }).catch((err) => {
        console.error(err);
    }).finally(() => {
        loading.value = false;
    });
})
const isPriorityArea = computed<boolean>(() => {
    const priorityAreaOptions = options.value.priorityAreas;
    if (priorityAreaOptions.length) {
        if (registration.value.priorityAreaId != null) {
            const item = priorityAreaOptions.find(x => x.value == registration.value.priorityAreaId);
            if (item && item.metadata.proofRequired) {
                return true;
            }
        }
    }
    return false;
})
const onInvalidSubmit = ({ errors }: InvalidSubmissionContext<any>) => {
    if (errors) {
        const messages = Object.values(errors);
        console.log(messages)
        validateMessages.value = messages;
    }
    if (validateMessages.value.length) {
        visibleNotice.value = true;
    }
}
const save = (setErrors: (fields: any) => void) => {
    validateMessages.value = [];
    if (registration.value) {
        visibleDialog.value = false;
        const url = token.value ? `/registration/thay-doi-thong-tin/${token.value}` : '/registration';
        submitting.value = true;
        axios.post<MethodResult<any>>(url, registration.value).then(res => {
            visibleNotice.value = false;
            const response = res.data;
            if (response.type == 'INVALID') {
                notices.value = null;
                const messsages: any = {};
                if (response.invalidMessages) {
                    for (const key in response.invalidMessages) {
                        messsages[key] = response.invalidMessages[key][0];
                    }
                }
                if (messsages) {
                    validateMessages.value = Object.values(messsages);
                    visibleNotice.value = true;
                    setErrors(messsages);
                }
            }
            if (response.type == 'DATA') {
                validateMessages.value = [];
                const data = response.data;
                if (data.success) {
                    const expiryDateEditLink = data.modifyAccessToken && data.modifyAccessToken.expiry ? moment(data.modifyAccessToken.expiry).format('DD/MM/yyyy HH:mm') : '';
                    notices.value = {
                        password: data?.accessKey,
                        email: data?.email,
                        expiryDateEditLink: expiryDateEditLink,
                        code: data?.code,
                        token: data.modifyAccessToken.token,
                        qrCode: data.qrCode
                    }
                } else {
                    validateMessages.value.push(data.errorMessage)
                }
            }
        }).catch((err: AxiosError) => {
            if (err.status == 400) {
                validateMessages.value.push('Dữ liệu không hợp lệ vui lòng kiểm tra lại');
            } else {
                validateMessages.value.push('Máy chủ đang bận vui lòng thử lại sau.');

            }
        }).finally(() => {
            submitting.value = false;
            if (validateMessages.value.length) {
                visibleNotice.value = true;
            }
            window.scrollTo(0, document.body.scrollHeight);
        })
    }
}
const onReset = (callBack: (state?: any) => void) => {
    callBack();
    //localStorage.removeItem('registration');
    initializeAsync().catch((err) => {
        console.error(err);
    }).finally(() => {
        loading.value = false;
        registration.value.id = '00000000-0000-0000-0000-000000000000';
        registration.value.code = null;
        registration.value.birthday = null;
        registration.value.dateGranted = null;
        registration.value.aspirations = [];
    });
}
const totalFee = computed(() => {
    return options.value.registrationFee;
})
const totalAspirations = computed(() => {
    if (registration.value.aspirations) {
        return registration.value.aspirations.length;
    }
    return 0
})
const copyLink = (link: string) => {
    navigator.clipboard.writeText(link);
}
const copyPassword = (password: string) => {
    navigator.clipboard.writeText(password);
}
const showPassword = () => {
    if (inputType.value === "password") {
        inputType.value = "text";
    } else {
        inputType.value = "password";
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createBlock(PageLoading, { key: 0 }))
        : (_openBlock(), _createBlock(_unref(Card), {
            key: 1,
            class: "form-container"
          }, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            title: _withCtx(() => [
              _createTextVNode(" PHIẾU ĐĂNG KÝ XÉT TUYỂN ĐẠI HỌC CHÍNH QUY ")
            ]),
            subtitle: _withCtx(() => [
              _createElementVNode("div", null, [
                _createTextVNode(" Thí sinh tra cứu hồ sơ đăng ký xét tuyển tại "),
                _createVNode(_component_router_link, { to: { name: 'tra-cuu' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(" đây ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createTextVNode(" Xem hướng dẫn đăng ký xét tuyển tại "),
                _createVNode(_component_router_link, { to: { name: 'guide' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(" đây ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_4
            ]),
            content: _withCtx(() => [
              _createVNode(_unref(Form), {
                "initial-values": registration.value,
                "validation-schema": _unref(schema),
                onSubmit: onRegister,
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ setFieldError, setErrors, resetForm }) => [
                  _createVNode(ThongTinChung, {
                    token: token.value,
                    "is-view-mode": isViewMode.value,
                    modelValue: registration.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registration).value = $event)),
                    options: options.value
                  }, null, 8, ["token", "is-view-mode", "modelValue", "options"]),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registration.value.placeOfStudies, (placeOfStudy, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(NoiHoc, {
                          modelValue: registration.value.placeOfStudies[index].highSchool,
                          "onUpdate:modelValue": ($event: any) => ((registration.value.placeOfStudies[index].highSchool) = $event),
                          name: `placeOfStudies[${index}].highSchool`,
                          code: placeOfStudy.code
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "code"])
                      ]))
                    }), 128))
                  ]),
                  _createVNode(KetQuaHocTap, {
                    marks: registration.value.subjectMarks,
                    "onUpdate:marks": _cache[1] || (_cache[1] = ($event: any) => ((registration.value.subjectMarks) = $event)),
                    "ielts-mark": registration.value.ieltsMark,
                    "onUpdate:ieltsMark": _cache[2] || (_cache[2] = ($event: any) => ((registration.value.ieltsMark) = $event)),
                    options: options.value,
                    "academic-rank": registration.value.academicRankId,
                    "onUpdate:academicRank": _cache[3] || (_cache[3] = ($event: any) => ((registration.value.academicRankId) = $event)),
                    foreignSubjectId: registration.value.foreignSubjectId,
                    "onUpdate:foreignSubjectId": _cache[4] || (_cache[4] = ($event: any) => ((registration.value.foreignSubjectId) = $event)),
                    "conduct-rank": registration.value.conductRankId,
                    "onUpdate:conductRank": _cache[5] || (_cache[5] = ($event: any) => ((registration.value.conductRankId) = $event)),
                    "ielts-date": registration.value.ieltsDate,
                    "onUpdate:ieltsDate": _cache[6] || (_cache[6] = ($event: any) => ((registration.value.ieltsDate) = $event)),
                    "graduation-year": registration.value.graduationYear,
                    "onUpdate:graduationYear": _cache[7] || (_cache[7] = ($event: any) => ((registration.value.graduationYear) = $event))
                  }, null, 8, ["marks", "ielts-mark", "options", "academic-rank", "foreignSubjectId", "conduct-rank", "ielts-date", "graduation-year"]),
                  _createVNode(MinhChung, {
                    "is-ielts-mark": registration.value.graduationYear == 2025 || registration.value.ieltsMark != null,
                    "is-priority-area": _unref(isPriorityArea),
                    "is-priority-object": registration.value.priorityObjectId != null,
                    group: registration.value.groupAttachment,
                    anhHocBaTrangDau: registration.value.anhHocBaTrangDau,
                    "onUpdate:anhHocBaTrangDau": _cache[8] || (_cache[8] = ($event: any) => ((registration.value.anhHocBaTrangDau) = $event)),
                    anhHocBaLop10: registration.value.anhHocBaLop10,
                    "onUpdate:anhHocBaLop10": _cache[9] || (_cache[9] = ($event: any) => ((registration.value.anhHocBaLop10) = $event)),
                    anhHocBaLop11: registration.value.anhHocBaLop11,
                    "onUpdate:anhHocBaLop11": _cache[10] || (_cache[10] = ($event: any) => ((registration.value.anhHocBaLop11) = $event)),
                    anhHocBaLop12: registration.value.anhHocBaLop12,
                    "onUpdate:anhHocBaLop12": _cache[11] || (_cache[11] = ($event: any) => ((registration.value.anhHocBaLop12) = $event)),
                    anhChungChiIelts: registration.value.anhChungChiIelts,
                    "onUpdate:anhChungChiIelts": _cache[12] || (_cache[12] = ($event: any) => ((registration.value.anhChungChiIelts) = $event)),
                    anhCanCuocCongDanMatTruoc: registration.value.anhCanCuocCongDanMatTruoc,
                    "onUpdate:anhCanCuocCongDanMatTruoc": _cache[13] || (_cache[13] = ($event: any) => ((registration.value.anhCanCuocCongDanMatTruoc) = $event)),
                    anhCanCuocCongDanMatSau: registration.value.anhCanCuocCongDanMatSau,
                    "onUpdate:anhCanCuocCongDanMatSau": _cache[14] || (_cache[14] = ($event: any) => ((registration.value.anhCanCuocCongDanMatSau) = $event)),
                    anhDoiTuongUuTien: registration.value.anhDoiTuongUuTien,
                    "onUpdate:anhDoiTuongUuTien": _cache[15] || (_cache[15] = ($event: any) => ((registration.value.anhDoiTuongUuTien) = $event)),
                    anhKhuVucUuTien: registration.value.anhKhuVucUuTien,
                    "onUpdate:anhKhuVucUuTien": _cache[16] || (_cache[16] = ($event: any) => ((registration.value.anhKhuVucUuTien) = $event)),
                    anhDatGiai: registration.value.anhDatGiai,
                    "onUpdate:anhDatGiai": _cache[17] || (_cache[17] = ($event: any) => ((registration.value.anhDatGiai) = $event)),
                    anhDiemNangKhieu: registration.value.anhDiemNangKhieu,
                    "onUpdate:anhDiemNangKhieu": _cache[18] || (_cache[18] = ($event: any) => ((registration.value.anhDiemNangKhieu) = $event))
                  }, null, 8, ["is-ielts-mark", "is-priority-area", "is-priority-object", "group", "anhHocBaTrangDau", "anhHocBaLop10", "anhHocBaLop11", "anhHocBaLop12", "anhChungChiIelts", "anhCanCuocCongDanMatTruoc", "anhCanCuocCongDanMatSau", "anhDoiTuongUuTien", "anhKhuVucUuTien", "anhDatGiai", "anhDiemNangKhieu"]),
                  (notices.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, "Bạn đã " + _toDisplayString(token.value ? 'cập nhật' : 'đăng ký') + " thành công", 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("ol", null, [
                              _hoisted_10,
                              _hoisted_11,
                              _createElementVNode("li", null, "Tổng số lệ phí xét tuyển thí sinh phải nộp là " + _toDisplayString(_unref(totalFee)) + "đ", 1),
                              _hoisted_12
                            ])
                          ])
                        ]),
                        (!validateMessages.value.length && notices.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (notices.value['code'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(notices.value['code']), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (notices.value['email'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _hoisted_18,
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(notices.value['email']), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (notices.value['password'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", null, _toDisplayString(notices.value['password']), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_router_link, { to: { name: 'tra-cuu' } }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Tra cứu thông tin đăng ký xét tuyển ")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ]),
                              (notices.value['token'] && !token.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_router_link, {
                                            to: { name: 'edit', params: { token: notices.value['token'] } }
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Sửa ")
                                            ]),
                                            _: 1
                                          }, 8, ["to"])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (notices.value['expiryDateEditLink'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(notices.value['expiryDateEditLink']), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (notices.value.qrCode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _hoisted_36,
                                    _createElementVNode("div", _hoisted_37, [
                                      _createVNode(_unref(Image), {
                                        src: notices.value?.qrCode
                                      }, null, 8, ["src"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_38, [
                    (!submitting.value)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          label: token.value ? 'Cập nhật' : 'Đăng ký',
                          type: "submit",
                          icon: "pi pi-check"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (submitting.value)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 1,
                          loading: true,
                          label: token.value ? 'Đang cập nhật' : 'Đang gửi đăng ký',
                          type: "button",
                          disabled: "",
                          icon: "pi pi-check"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (!token.value)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 2,
                          severity: "danger",
                          label: "Làm lại",
                          icon: "pi pi-times",
                          onClick: ($event: any) => (onReset(resetForm))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_unref(Dialog), {
                    visible: visibleDialog.value,
                    "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((visibleDialog).value = $event)),
                    modal: "",
                    header: "Lưu ý",
                    breakpoints: breakpoints,
                    style: { width: '35vw' }
                  }, {
                    footer: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        label: "Đóng",
                        icon: "pi pi-times",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (visibleDialog.value = false)),
                        text: ""
                      }),
                      _createVNode(_unref(Button), {
                        label: "Đồng ý",
                        icon: "pi pi-check",
                        onClick: ($event: any) => (save(setErrors)),
                        autofocus: ""
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 2
                  }, 1032, ["visible"])
                ]),
                _: 1
              }, 8, ["initial-values", "validation-schema"])
            ]),
            _: 1
          }))
    ]),
    _createVNode(_unref(Dialog), {
      visible: visibleNotice.value,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((visibleNotice).value = $event)),
      modal: "",
      header: "Thông báo",
      breakpoints: breakpoints,
      contentClass: "w-full",
      style: { width: '30vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          label: "Đóng",
          icon: "pi pi-times",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (visibleNotice.value = false)),
          text: ""
        })
      ]),
      default: _withCtx(() => [
        (validateMessages.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validateMessages.value, (message, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(message), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})